export const getAiPlanContentQueryFn = async props => {
  const {
    httpClient,
    request
  } = props;
  const response = await httpClient.post('https://manage.wix.com/_api/premium-package-pickers-api/get-ai-plan-content', request);
  return response.data;
};
//# sourceMappingURL=get-ai-plan-content.query.js.map